// Log a bunch of things together. Image components also import this in the
// browser, so use the logger's formatter instead of Node's util polyfill.
import { htRandom } from '.'
import { createLogger, formatPrintf } from '../log/client'

const log = createLogger('tracer')

const tracingDisabled = true

interface MessageProps {
  message: string
  optionalParams: unknown[]
}
export interface TracerType {
  trace: (message: string, ...optionalParams: unknown[]) => number
  dump: () => string
  log: (group: string) => void
  raw: MessageProps[]
}

const tracer = (): TracerType => {
  const traces: MessageProps[] = []
  return {
    raw: traces,
    trace: (message: string, ...optionalParams: unknown[]) => traces.push({ message, optionalParams }),
    dump: () => traces.map(({ message, optionalParams }) => formatPrintf(message, optionalParams)).join('\n'),
    log: (group) => {
      if (tracingDisabled) {
        return
      }
      const g = `${group}-${Math.floor(htRandom() * 1000)}`
      if (typeof window === 'undefined') {
        const args: unknown[] = [g]
        const out = ['----- start of %s -----']
        traces.forEach((t, idx) => {
          const { message, optionalParams } = t
          out.push(`${g}-${idx}: ${message}`)
          if (optionalParams) {
            args.push(...optionalParams)
          }
        })
        out.push('----- end of %s -----')
        args.push(g)
        log.trace(out.join('\n'), ...args)
      } else {
        console.group(g)
        log.trace('traces: %d', traces.length)
        traces.forEach((t, idx) => {
          const { message, optionalParams } = t
          if (optionalParams) {
            log.trace(`${idx}: ${message}`, ...optionalParams)
          } else {
            log.trace(`${idx}: ${message}`)
          }
        })
        log.trace(`end of trace ${g}`)

        console.groupEnd()
      }
    },
  }
}

export default tracer
